import React, { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { onUserProfileLoad, onUserProfileUpdate } from "../../../store/Settings/actions";
import * as yup from "yup";
import 'react-toastify/dist/ReactToastify.css';

export const UserProfile = () => {
    const [data, setData] = useState({
        name: "",
        email: "",
        confirm_email: "",
    })
    const dispatch = useDispatch();
    const { t } = useTranslation();    
    
    const { redirect, name, email } = useSelector(({settings}) => ({
        redirect: settings.redirect,
        name: settings.user_profile.name,
        email: settings.user_profile.email,
    }));

    useEffect(()=>{setData((prevState) => ({...prevState, name, email}))},[name, email])
    useEffect(()=>{redirect && dispatch(onUserProfileLoad())},[redirect])
    
    const handleSubmit = async (values, {resetForm}) => {
        dispatch(onUserProfileUpdate(values));                       
        resetForm({ name, email, confirm_email: ""});
    }
   
    const emailValidationSchema = yup.object().shape({
        name: yup.string().required(t("Required")),
        email: yup
            .string()      
            .email(t("Invalid email format"))
            .required(t("Mail is required"))
            .matches(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            ),
        confirm_email: yup
            .string()
            .required(t("Please confirm your email"))
            .oneOf([yup.ref("email")], t("Email do not match")),
    });

    return (
        <div className="rounded-lg shadow-md bg-white pt-5 pr-12 pb-4 pl-5">
            <Formik
                enableReinitialize
                initialValues={data}
                onSubmit={handleSubmit}
                validationSchema={emailValidationSchema}
            >
                {({ errors, touched }) => (
                    <Form>
                        <p className="font-bold text-base">{t("User Profile")}</p>
                        <span className="text-xs text-gray-600">
                            {t("Update your account's profile information and email address.")}
                        </span>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="name"
                                className="block text-xs font-semibold"
                            >
                                {t("Name")}
                            </label>
                            <Field
                                type="text"
                                name="name"
                                placeholder={t("Name")}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                            {errors.name &&
                                touched.name && (
                                    <div className="text-red-500 text-sm mt-1 ml-2">
                                        {errors.name}
                                    </div>
                                )}
                        </div>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="email"
                                className="block text-xs font-semibold"
                            >
                                {t("Email")}
                            </label>
                            <Field
                                type="email"
                                name="email"
                                placeholder={t("Email")}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                            {errors.email &&
                                touched.email && (
                                    <div className="text-red-500 text-sm mt-1 ml-2">
                                        {errors.email}
                                    </div>
                                )}
                        </div>

                        <div className="col-span-3 sm:col-span-3 py-3.5">
                            <label
                                htmlFor="confirm_email"
                                className="block text-xs font-semibold"
                            >
                                {t("Confirm Email")}
                            </label>
                            <Field
                                type="email"
                                name="confirm_email"
                                placeholder={t("Confirm Email")}
                                className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
                            />
                            {errors.confirm_email &&
                                touched.confirm_email && (
                                    <div className="text-red-500 text-sm mt-1 ml-2">
                                        {errors.confirm_email}
                                    </div>
                                )}
                        </div>

                        <div className="py-3 text-right">                                
                            <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-7 border border-transparent shadow-sm text-sm font-bold rounded-lg text-white bg-gray-900 hover:bg-gray-700 activ:bg-gray-800 focus:outline-none"
                            >
                                {t("Update")}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};
